import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  pesquisasSatisfacao: [],
  pesquisaSatisfacaoEspecifica: {},
  pesquisaUse: {},
  audios: [],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
